import BtnDeleteValue from './BtnDeleteValue';
import Details from './Details';
import { memo } from 'react';

const Device = memo(function Device({
  devices,
  device,
  unit,
  counterValues,
  handleMeterReadingInput,
  calculationProgress,
  calcResultValues,
  consumptionValues,
  calcPayment,
  handleDeletePrevValue,
  handleCloseFansyBox
}) {
  return (
    <div class="counter-form-section__item" data-entity="meter-reading-container" key={device.number} style={{ marginBottom: '5px' }}>
      <div class="counter-form-section__counter-wrapper" style={{ marginBottom: '10px' }}>
        <div class="counter-form-section__counter-title">Прибор учета</div>
        <div class="counter-form-section__counter">{device.serialNumber}</div>
      </div>
      <div class="counter-form-section__field-wrap" style={{ marginTop: '10px' }}>
        <div class="counter-form-section__testimony-field">
          <div class="counter-form-section__testimony-title">Текущие показания</div>
          <input
            class="form-field__input counter-form-section__testimony-value input input_bgc_ui-2"
            inputmode="decimal"
            data-entity="meter-reading-input"
            value={counterValues[device.number] || ''}
            onInput={(e) => {
              clearTimeout(e.target.timer);
              e.target.timer = setTimeout(() => {
                handleMeterReadingInput(device, e);
              }, 1000);
            }}
            disabled={calculationProgress}
          />
        </div>
        <div>
          <div class="counter-form-section__testimony-title">Предыдущие значения</div>
          <div class="counter-form-section__testimony-value">
            <div class="counter-form-section__testimony-value-line">
              <div class="counter-form-section__testimony-count">
                {device.meterReading}
              </div>
              <div class="counter-form-section__testimony-date">
                от {device.dateMeterReading}
              </div>
            </div>
            <div class="counter-form-section__testimony-value-line">
              <div class="counter-form-section__testimony-tariff">
                Источник показаний:<br />
                &nbsp; - {device.valueType}
              </div>
            </div>
            {devices.length == 1 && device.canDeleteValue &&
              <BtnDeleteValue
                device={device}
                onDelete={handleDeletePrevValue}
                onClose={handleCloseFansyBox}
              />
            }
          </div>
        </div>
      </div>

      <div class="counter-form-section__field-wrap" style={{ marginTop: '10px' }}>
        <div class="services counter-form-section__testimony-title"
          dangerouslySetInnerHTML={{ __html: (calcResultValues[device.number] || '') }}
        />
      </div>

      {devices.length > 0 && !device.isHeating &&
        <Details
          device={device}
          calcResultValues={calcResultValues}
          consumptionValues={consumptionValues}
          calcPayment={calcPayment}
          unit={unit}
        />
      }
    </div>
  );
});

export default Device;